import { GetServerSidePropsContext } from 'next'

import CardLists from '@/components/CardLists/CardLists'
import ComboDescription from '@/components/ComboDescription/ComboDescription'
import Container from '@/components/Container/Container'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import Tabs from '@/components/Tabs/Tabs'
import { ComboData, GenericPageProps } from '@/types/page'
import { COLORS } from '@/utils/constants'
import { serverSidePropsFor } from '@/utils/helpers.server'

type Props = GenericPageProps & {
  data: { combo: ComboData }
}

const CombosSubSubPage = ({ data }: Props) => (
  <Main>
    <DefaultHead data={data} />
    <Container className='mb-2'>
      <SimpleHeader>{data.header}</SimpleHeader>
      <ComboDescription combo={data.combo} headerList={(data.container.json_dict.cardlists || [])[0]} />
    </Container>
    <Tabs />
    <CardLists initCardLists={data.container.json_dict.cardlists?.slice(1)} />
  </Main>
)

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  if (context.query.slug !== 'colorless' && COLORS.hasOwnProperty(context.query.slug as string)) {
    const colorName = COLORS[context.query.slug as keyof typeof COLORS].toLowerCase()
    return {
      redirect: {
        destination: `/combos/${colorName}/${context.query.comboNumber}`,
        permanent: true,
      },
    }
  }
  return serverSidePropsFor(
    `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/combos/${context.query.slug}/${context.query.comboNumber}.json`,
  )
}

export default CombosSubSubPage
